import { insertSymptoms, getUserSymptoms, deleteAllSymptoms } from '../util/api';

export const INSERT_SYMPTOMS_REQUEST = 'app/symptoms/INSERT_SYMPTOMS_REQUEST';
export const INSERT_SYMPTOMS_SUCCESS = 'app/symptoms/INSERT_SYMPTOMS_SUCCESS';
export const INSERT_SYMPTOMS_ERROR = 'app/symptoms/INSERT_SYMPTOMS_ERROR';

export const FETCH_SYMPTOMS_REQUEST = 'app/symptoms/FETCH_SYMPTOMS_REQUEST';
export const FETCH_SYMPTOMS_SUCCESS = 'app/symptoms/FETCH_SYMPTOMS_SUCCESS';
export const FETCH_SYMPTOMS_ERROR = 'app/symptoms/FETCH_SYMPTOMS_ERROR';

export const DELETE_SYMPTOMS_REQUEST = 'app/symptoms/DELETE_SYMPTOMS_REQUEST';
export const DELETE_SYMPTOMS_SUCCESS = 'app/symptoms/DELETE_SYMPTOMS_SUCCESS';
export const DELETE_SYMPTOMS_ERROR = 'app/symptoms/DELETE_SYMPTOMS_ERROR';

export const initialState = {
  isSubmitting: false,
  submitSuccess: false,
  error: null,
  symptoms: [],
  isFetching: false,
  fetchError: null,
  isDeleting: false,
  deleteSuccess: false,
  deleteError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case INSERT_SYMPTOMS_REQUEST:
      return { ...state, isSubmitting: true, error: null };
    case INSERT_SYMPTOMS_SUCCESS:
      return { ...state, isSubmitting: false, submitSuccess: true, error: null };
    case INSERT_SYMPTOMS_ERROR:
      return { ...state, isSubmitting: false, submitSuccess: false, error: payload };
    case FETCH_SYMPTOMS_REQUEST:
      return { ...state, isFetching: true, fetchError: null };
    case FETCH_SYMPTOMS_SUCCESS:
      return { ...state, isFetching: false, symptoms: payload, fetchError: null };
    case FETCH_SYMPTOMS_ERROR:
      return { ...state, isFetching: false, fetchError: payload };
    case DELETE_SYMPTOMS_REQUEST:
      return { ...state, isDeleting: true, deleteError: null };
    case DELETE_SYMPTOMS_SUCCESS:
      return { ...state, isDeleting: false, deleteSuccess: true, deleteError: null };
    case DELETE_SYMPTOMS_ERROR:
      return { ...state, isDeleting: false, deleteSuccess: false, deleteError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const insertSymptomsRequest = () => ({ type: INSERT_SYMPTOMS_REQUEST });
export const insertSymptomsSuccess = () => ({ type: INSERT_SYMPTOMS_SUCCESS });
export const insertSymptomsError = error => ({ type: INSERT_SYMPTOMS_ERROR, payload: error });

export const fetchSymptomsRequest = () => ({ type: FETCH_SYMPTOMS_REQUEST });
export const fetchSymptomsSuccess = symptoms => ({
  type: FETCH_SYMPTOMS_SUCCESS,
  payload: symptoms,
});
export const fetchSymptomsError = error => ({ type: FETCH_SYMPTOMS_ERROR, payload: error });

export const deleteSymptomsRequest = () => ({ type: DELETE_SYMPTOMS_REQUEST });
export const deleteSymptomsSuccess = () => ({ type: DELETE_SYMPTOMS_SUCCESS });
export const deleteSymptomsError = error => ({ type: DELETE_SYMPTOMS_ERROR, payload: error });

// ================ Thunks ================ //

export const insertSymptomsData = state => {
  return {
    isSubmitting: state.symptoms.isSubmitting,
    submitSuccess: state.symptoms.submitSuccess,
    error: state.symptoms.error,
  };
};

export const fetchSymptomsData = state => {
  return {
    symptoms: state.symptoms.symptoms,
    isFetching: state.symptoms.isFetching,
    fetchError: state.symptoms.fetchError,
  };
};

export const deleteSymptomsData = state => {
  return {
    isDeleting: state.symptoms.isDeleting,
    deleteSuccess: state.symptoms.deleteSuccess,
    deleteError: state.symptoms.deleteError,
  };
};

export const insertSymptomsAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(insertSymptomsRequest());
  try {
    const result = await insertSymptoms(params);
    dispatch(insertSymptomsSuccess());
    return result;
  } catch (error) {
    console.error('Error inserting symptoms:', error);
    dispatch(insertSymptomsError(error.message || 'Failed to submit symptoms'));
    throw error;
  }
};

export const fetchSymptomsAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchSymptomsRequest());
  try {
    const result = await getUserSymptoms(params);
    dispatch(fetchSymptomsSuccess(result.symptoms || []));
    return result;
  } catch (error) {
    console.error('Error fetching symptoms:', error);
    dispatch(fetchSymptomsError(error.message || 'Failed to fetch symptoms'));
    throw error;
  }
};

export const deleteSymptomsAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(deleteSymptomsRequest());
  try {
    // Use the existing insertSymptoms API with deleteRecord flag
    const deleteParams = {
      ...params,
      symptoms_list: [],
      deleteRecord: true,
    };
    const result = await insertSymptoms(deleteParams);
    dispatch(deleteSymptomsSuccess());
    return result;
  } catch (error) {
    console.error('Error deleting symptoms:', error);
    dispatch(deleteSymptomsError(error.message || 'Failed to delete symptoms'));
    throw error;
  }
};

export const deleteAllSymptomsAction = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(deleteSymptomsRequest());
  try {
    const result = await deleteAllSymptoms(params);
    dispatch(deleteSymptomsSuccess());
    return result;
  } catch (error) {
    console.error('Error deleting all symptoms:', error);
    dispatch(deleteSymptomsError(error.message || 'Failed to delete all symptoms'));
    throw error;
  }
};
